import get from 'transmute/get';
export const getIsPausedOn = get('isPausedOn');